import React from 'react'
const files = require.context('!svg-sprite-loader!./assets', false, /.*\.svg$/)
files.keys().forEach(files)
import './icon.scss'

export default function Icon({ type, className, size, withShadow, style }) {
    const classList = ['icon']
    if (className) classList.push(className)
    if (size) classList.push(`icon--${size}`)
    if (withShadow) classList.push(`icon--shadow`)

    return (
        <svg className={classList.join(' ')} style={style}>
            <use xlinkHref={`#${type}`}></use>
        </svg>
    )
}

Icon.propTypes = {
    type: PropTypes.string,
    withShadow: PropTypes.bool,
    size: PropTypes.oneOf(['xxs', 'xs', 'sm', 'smd', 'md', 'lg', 'xl', 'xxxl']),
}
